export default "__VITE_ASSET__DUQnjat0__"